module.exports = new __parcel__URL__("20809_h.5347123b.jpg").toString();